module.exports = __webpack_public_path__ + "img/icon_map_10_off_011.8c1f9b7a.png";